"use client"

import { useEffect } from "react"
import { create } from "zustand"

const STORAGE_KEY = "gw-client-view"

interface ClientViewState {
  isClientView: boolean
  setClientView: (next: boolean) => void
  toggleClientView: () => void
}

export const useClientViewStore = create<ClientViewState>((set, get) => ({
  isClientView: false,
  setClientView: (next: boolean) => {
    if (typeof window !== "undefined") {
      window.localStorage.setItem(STORAGE_KEY, next ? "1" : "0")
    }
    set({ isClientView: next })
  },
  toggleClientView: () => get().setClientView(!get().isClientView),
}))

export function ClientViewSyncer() {
  const setClientView = useClientViewStore((state) => state.setClientView)

  useEffect(() => {
    if (typeof window === "undefined") return
    const stored = window.localStorage.getItem(STORAGE_KEY)
    if (stored === "1") setClientView(true)
  }, [setClientView])

  return null
}
